import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContratSav, Installation } from 'src/app/model/installation/installation.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';
import { UserService } from 'src/app/services/http/user/user.service';

@Component({
  selector: 'app-installation',
  templateUrl: './installation.component.html',
  styleUrls: ['./installation.component.scss']
})

export class InstallationComponent implements OnInit {


  constructor(private service: InstallationsService, private activatedRoute: ActivatedRoute, private userService: UserService) { }
  public sep: string = ' ';
  public installation!: Installation;
  public identifiant !: string;
  public contratSav !: ContratSav;
  public tJour = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
  public tMois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

  public restricted!: boolean;

  get displayedColumn(): string[] {
    const result: string[] = ['nom'];
    return result;
  }

  ngOnInit(): void {

    this.restricted = localStorage.getItem('restricted')=='true';
    const params = this.activatedRoute.snapshot.params
    this.identifiant = params.id;

    this.service.getInstallation(this.identifiant)
      .subscribe((installation) => {
        this.getCorrectInstallProprioDisplay(installation.societe_proprietaire.proprietaires);
        this.installation = installation;
      });


    this.service.getContratSavData(this.identifiant)
      .subscribe((contratSav) => {
        this.contratSav = contratSav;
      })


  }


  /** Properly display 'propriétaires' if there is more than one */
  public getCorrectInstallProprioDisplay(proprio: Array<any>) {
    let result = '';
    let lastOne = proprio[proprio.length - 1];
    for (let i = 0; i < proprio.length; i++) {
      if (proprio.length > 1) {
        if (proprio[i] !== (lastOne)) {
          result += proprio[i].nom_personne + ' / ';
        }
        if (proprio[i] == (lastOne)) result += proprio[i].nom_personne;
      } else {
        result = proprio[i].nom_personne;
      }
    }
    return result;
  }

  /**
 * Display date into human format
 */
  public convertDate(date: string): string {

    let newDate = Date.parse(date);
    let correctDate = new Date(newDate);
    let result = this.tJour[correctDate.getDay() - 1] + ' ' + correctDate.getDate() + ' ' + this.tMois[(correctDate.getMonth())] + ' ' + correctDate.getFullYear() + ' à ' + correctDate.getHours() + ':' + this.getCorrectMinuteDisplay(correctDate);
    return result;

  }


  /**Enhance minutes display */
  public getCorrectMinuteDisplay(date: Date): any {
    if (date.getMinutes() < 10) return '0' + date.getMinutes();
    else return date.getMinutes();
  }

  /**
   * Display installation model properly
   * if model name is undefined : then we display 'N/A' 
   * */
  public getMOdelInstallationName(installation: Installation) : string {
    if (installation.installation_projet.model.name) {
      return installation.installation_projet.model.name;
    } else {
      return 'N/A';
    }
  }


  public getInstallationIPAdress(installation : Installation) : string {

    let ip : string = installation.installation_network.last_ip;
    let telecollect : string = installation.installation_network.last_telecollecte;

    let result : string = "";

    if ( ip.length > 0 && telecollect.length > 0) {
      result = ip + this.sep + '( ' + this.convertDate(telecollect) + ' )'; 
    } else if ( ip.length > 0 && telecollect.length == 0 ) {
      result = ip;
    } else if ( ip.length == 0 && telecollect.length > 0 ) {
      result = "N/A";
    } else if ( ip.length == 0 && telecollect.length == 0 ) {
      result = "N/A";
    }

    return result;    
  }

  

}
